export const MIN_BET_VALUE = 1.0;
export const MAX_BET_VALUE = 999999;
export const GAMES_INCREASE_MIN = -100;
export const GAMES_INCREASE_MAX = 10000;
